import styled from "@emotion/styled/macro";
import { Badge, BadgeProps } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";

const StatusBadge = styled(Badge)<IStyledComponentProps & BadgeProps>`
  &.badge {
    border-radius: 0;
    width: 72px;
    font-size: 11px;
    padding: 6px 0;
    font-family: ${({ theme }) => theme.fontFamilies.semiBold};
  }
`;

export default { StatusBadge };
